import {useAllCoursesQuery, useLanguagesQuery} from "../../types.d";
import * as React from "react";
import {useEffect, useState} from "react";

export interface CourseFilterProps {
    onChange: (id: number) => any;
}

export const CourseFilter = (props: CourseFilterProps) => {
    const [value, setValue] = useState<number>();
    const courses = useAllCoursesQuery({
        fetchPolicy: 'no-cache'
    });

    if (!courses.data) {
        return null;
    }

    return <select
        className={'form-control'}
        onChange={value => {
            const id = Number(value.currentTarget.value);
            setValue(id);
            props.onChange(id);
        }}
        value={value}
    >
        <option
            value={0}
            key={0}>All</option>

        { courses.data && courses.data.courses.map(item => (
            <option
                value={item.id}
                key={item.id}>{ item.sourceLanguage.name } -> { item.translationLanguage.name }</option>
        )) }
    </select>
};
